import type { Meta, StoryObj } from "@storybook/react";

import type { SectionHeaderProps } from "@/ui/core";
import { SectionHeader } from "@/ui/core";

const StoryMeta: Meta<SectionHeaderProps> = {
  title: "Core/Section Header",
  component: SectionHeader,
  argTypes: {
    accessibilityLabel: { control: "text" },
    appUserBadgeCount: { control: "number" },
    isAppUserSupport: { control: "boolean" },
    onUserChange: { action: "User changed" },
    testID: { control: "text" },
    title: { control: "text" },
    userTabs: { control: "object" },
  },
  args: {
    accessibilityLabel: "Storybook Section",
    appUserBadgeCount: 4,
    appUserId: "jessica_001",
    isAppUserSupport: true,
    testID: "storybook",
    title: "Schedule",
    userTabs: [
      {
        badgeCount: 4,
        userId: "jessica_001",
        userName: "Jessica",
      },
      {
        badgeCount: 1,
        userId: "sebastian_002",
        userName: "Sebastian",
      },
    ],
  },
};

type Story = StoryObj<SectionHeaderProps>;

export const Primary: Story = {};
export default StoryMeta;
